module.exports = __webpack_public_path__ + "static/media/Performact Logo.059c92c3.png";